export default "src/content/themes/association-wordpress-theme/img/9d13e767aa9b6684ce8223e76033f0c9.png";